import { useEffect } from "react";

export function Container({ isValidEmail, setIsValidEmail, input, setInput }) {
	const container = document.querySelector(".container");
	const confirmationContainer = document.querySelector(
		".confirmation-container"
	);
	const invalid = document.querySelector(".invalid");

	useEffect(
		function () {
			const emailPattern = /^[^\s@]+@[^\s@]+\.[a-zA-Z]{2,}$/;
			setIsValidEmail(emailPattern.test(input));
		},
		[input, isValidEmail, setIsValidEmail]
	);

	function handleButtonClick() {
		if (isValidEmail) {
			container.classList.add("vanish");
			confirmationContainer.classList.remove("vanish");
		} else {
			invalid.classList.remove("vanish");
		}
	}

	return (
		<main className="container">
			<div className="email-field">
				<article className="writing">
					<h1>Stay updated!</h1>
					<p>Just 60000+ prodect managers receiving monthly updates on:</p>
					<ul>
						<li>Product discovery and building what matters</li>
						<li>Measuring to nesure updates are a success</li>
						<li>and much more!</li>
					</ul>
				</article>
				<div className="form">
					<p>
						<strong>Email address</strong>
						<em className="invalid vanish">Invalid email !!</em>
					</p>
					<input
						type="text"
						name="email"
						value={input}
						onChange={(e) => setInput(e.target.value)}
						placeholder="email@company.com"
						required
					></input>
				</div>
				<button className="btn" onClick={handleButtonClick}>
					Subcribe to monthly newsletter
				</button>
			</div>
			<figure className="image-field"></figure>
		</main>
	);
}
